import actionCreatorFactory from 'typescript-fsa';
import { IApprovalStayMealData } from './search';

const actionCreator = actionCreatorFactory();

/** 表の表示形式 */
export enum ImstatShowTypes {
	IMSTAT_SHOW_TYPE_TABLE,
	IMSTAT_SHOW_TYPE_CARD,
}

/** eラーニング情報 */
export interface IELearning {
	aplType: string; // 申請種別
	compulsoryID: string; // 区分
	careerSubTitle: string; // サブ種別
	careerTitle: string; // 研修名
	classTitle: string; // クラス名
	jissiKikan: string; // 実施期間
	startDateODT: Date; // 開始日（daoからの取得用）
	endDateODT: Date; // 終了日（daoからの取得用）
	target: string; //   対象者
	organizer: string; // 教育主催者
	credit: string; // 単位
	kikan: string; // 標準学習時間
	cost: string; // 費用（円）
	kadai: string; // 課題（提出数/全体数）
	kadaiWithin: number; // 課題提出可能数
	enquete: string; // アンケート（回答数/全体数）
	enqueteWithin: number; // アンケート回答可能数
	status: string; // 統合版ステータス
	imstatListStatusId: number; // ステータスId
	jukou: string; // 受講
	sinseiUID: string; // 受講申請ユーザ
	sinseiDate: string; // 受講申請日時（uiへの返却用）
	sinseiDateODT: Date; // 受講申請日時（daoからの取得用）
	jissiStartDateODT: Date; // 実施期間開始日
	jissiEndDateODT: Date; // 実施期間終了日
	approvalUID: string; // 受講最終承認者
	approvalDateODT: Date; // 受講承認日時（daoからの取得用）
	contentFlg: string; // コンテンツ存在判定用フラグ
	approvalDate: string; // 受講承認日時（uiへの返却用）
	careerID: string; // キャリアID
	classID: string; // クラスID
	careerTypeID: string; // キャリア種別
	outOfPeriodFlg: boolean; // 実施期間外フラグ
	elViewMode: number; // 受講時参照モード(0:編集可能、1:参照モード）
	compulsoryCssClass: string; // 区分値cssClass（区分別の行色分けに影響）
	enqueteDispFlg: boolean; // アンケート回答可能フラグ（操作メニューに影響）
	taskReportOkFlg: boolean; // 課題提出可能フラグ（操作メニューに影響）
	externalCourseType: number; // Udemy研修の場合
}

/** 実施中eラーニング情報 */
export interface IOnGoingELearning extends IELearning {
	zanNissuu: string; // 残日数
	progress: number; // 進捗率
	mousikomiKikan: string; // 申込期間
	approvalStageCode: string; // 承認段階コード
	courseStartDate: string; // 開始日（uiへの返却用）
	courseEndDate: string; // 終了日（uiへの返却用）
	mousikomiFromODT: Date; //  * 申し込み期間開始日
	mousikomiToODT: Date; // 申し込み期間終了日
	classStatus: string; // クラスステータス
	appChangeOkFlg: boolean; // 申請変更可能フラグ（操作メニューに影響）
	appCancelOkFlg: boolean; // 申請取消可能フラグ（操作メニューに影響）
	lecCancelOkFlg: boolean; // 受講キャンセル可能フラグ（操作メニューに影響）
	appResultOkFlg: boolean; // 実績申請可能フラグ（操作メニューに影響）
	createProgressLinkFlg: boolean; // 進捗率リンク作成フラグ
	testFlg: boolean; // テスト履歴表示フラグ
	uncompletedCareers: string; // 終了していない前提キャリア
	unrepresentedCareerCnt: string; // 表示していない前提キャリアの件数
}

/** 実績eラーニング情報 */
export interface IResultELearning extends IELearning {
	sousa: string; // 操作
	updateDate: string; // 更新日（UIへの返却用）
	resultStatus: number; // 結果ステータス
	certificateDispFlg: boolean; // 修了証明書ボタン表示フラグ
	referenceOkFlg: boolean; // 実績参照ボタン表示フラグ
	retakeOkFlg: boolean; // 再申請ボタン表示フラグ
	sikkouFlg: string; // 失効フラグ
	schFlg: string; // 学習者履歴フラグ
	seq: string; // シーケンス番号
	reasonCode: string; // 原因コード
	unionBlockNo: string; // Unionブロック番号
	multiApplyFlag: string; // 再受講フラグ
	startDate: string; // 開始日
	endDate: string; // 終了日
	testFlg: boolean; // テスト履歴表示フラグ
}

/** 集合研修情報 */
export interface IGroupTraining {
	aplType: string; // 申請種別
	compulsoryID: string; // 	区分
	careerSubTitle: string; // サブ種別
	careerTitle: string; // 研修名
	sousa: string; // 操作
	classTitle: string; // クラス名
	jissiKikan: string; // 実施期間
	jissiStartDateODT: Date; // 実施期間開始日
	jissiEndDateODT: Date; // 実施期間終了日
	classroom: string; // 実施場所
	cost: string; // 費用(円)
	credit: string; // 単位
	days: string; // 日数
	target: string; // 対象者
	organizer: string; // 教育主催者
	mousikomiKikan: string; // 申込期間
	kadai: string; // "課題（提出数/課題総数）"
	enquete: string; // アンケート（回答数/ｱﾝｹｰﾄ総数）
	status: string; // ステータス
	sinseiUID: string; // 受講申請ユーザ
	sinseiDate: string; // 受講申請日時
	approvalUID: string; // 受講最終承認者
	approvalDate: string; // 受講承認日時
	careerID: string; // キャリアID
	careerTypeID: string; // キャリア種別
	classID: string; // クラスID
	compulsoryCssClass: string; // 区分値cssClass
	taskReportOkFlg: boolean; // 課題提出可能フラグ（操作メニューに影響）
	outOfPeriodFlg: string; // 実施期間外フラグ
	enqueteDispFlg: string; // アンケート回答可能フラグ（操作メニューに影響）
}

/** 実施中集合研修情報 */
export interface IOnGoingGroupTraining extends IGroupTraining {
	appChangeOkFlg: boolean; // 申請変更可能フラグ（操作メニューに影響）
	appCancelOkFlg: boolean; // 申請取消可能フラグ（操作メニューに影響）
	lecCancelOkFlg: boolean; // 受講キャンセル可能フラグ（操作メニューに影響）
	appResultOkFlg: boolean; // 実績申請可能フラグ（操作メニューに影響）
}

/** 実績集合研修情報 */
export interface IResultGroupTraining extends IGroupTraining {
	complDate: string; // 修了日（画面への応答用）
	certificateDispFlg: boolean; // 修了証明書ボタン表示フラグ（操作メニューに影響）
	referenceOkFlg: boolean; // 実績参照可能フラグ（操作メニューに影響）
	retakeOkFlg: boolean; // 再申請可能フラグ（操作メニューに影響）
	seq: string; // シーケンス番号
	imstatListStatusId: number; // ステータスId
	reasonCode: string; // 原因コード
}

/** 通信教育情報 */
export interface IDistanceLearning {
	aplType: string; // 申請種別
	compulsoryID: string; // 	区分
	careerSubTitle: string; // サブ種別
	careerTitle: string; // 研修名
	sousa: string; // 操作
	classTitle: string; // クラス名
	jissiKikan: string; // 実施期間
	jissiStartDateODT: Date; // 実施期間開始日
	jissiEndDateODT: Date; // 実施期間終了日
	cost: string; // 費用(円)
	credit: string; // 単位
	target: string; // 対象者
	organizer: string; // 教育主催者
	kadai: string; // "課題（提出数/課題総数）"
	enquete: string; // アンケート（回答数/ｱﾝｹｰﾄ総数）
	status: string; // ステータス
	sinseiUID: string; // 受講申請ユーザ
	sinseiDate: string; // 受講申請日時
	approvalUID: string; // 受講最終承認者
	approvalDate: string; // 受講承認日時
	careerID: string; // キャリアID
	classID: string; // クラスID
	compulsoryCssClass: string; // 区分値cssClass
	taskReportOkFlg: boolean; // 課題提出可能フラグ（操作メニューに影響）
	enqueteDispFlg: string; // アンケート回答可能フラグ（操作メニューに影響
	outOfPeriodFlg: string; // 実施期間外フラグ
}

/** 実施中通信教育情報 */
export interface IOnGoingDistanceLearning extends IDistanceLearning {
	mousikomiKikan: string; // 申込期間
	appChangeOkFlg: boolean; // 申請変更可能フラグ（操作メニューに影響）
	appCancelOkFlg: boolean; // 申請取消可能フラグ（操作メニューに影響）
	lecCancelOkFlg: boolean; // 受講キャンセル可能フラグ（操作メニューに影響）
	appResultOkFlg: boolean; // 実績申請可能フラグ（操作メニューに影響）
}

/** 実績通信教育情報 */
export interface IResultDistanceLearning extends IDistanceLearning {
	complDate: string; // 修了日（画面への応答用）
	imstatListStatusId: number; // ステータスId
	reasonCode: string; // 原因コード
	seq: string; // シーケンス番号
	certificateDispFlg: boolean; // 修了証明書ボタン表示フラグ（操作メニューに影響）
	referenceOkFlg: boolean; // 実績参照可能フラグ（操作メニューに影響）
	retakeOkFlg: boolean; // 再申請可能フラグ（操作メニューに影響）
}

/** カリキュラム情報 */
export interface ICurriculum {
	compulsoryID: string; // 区分
	careerTitle: string; // 研修名
	sousa: string; // 操作
	target: string; //   対象者
	organizer: string; // 教育主催者
	credit: string; // 単位
	status: string; // 統合版ステータス
	statusId: string; // ステータスID
	applyUserId: string; // 受講申請ユーザ
	applyDate: string; // 受講申請日時（UIへの返却用）
	applyDateODT: Date; // 受講申請日時（Daoからの取得用）
	approvalUserId: string; // 受講最終承認者
	approvalDate: string; // 受講承認日時（UIへの返却用）
	approvalDateODT: Date; // 受講承認日時（Daoからの取得用）
	compulsoryCssClass: string; // 区分値cssClass（区分別の行色分けに影響）
	careerID: string; // キャリアID
	appCancelOkFlg: boolean; // 申請取消可能フラグ（操作メニューに影響）
	lecCancelOkFlg: boolean; // 受講キャンセル可能フラグ（操作メニューに影響）
	aplType: string; // 申請種別
	complDate: string; // 修了日（画面への応答用）
	complDateODT: Date; // 修了日（Daoからの取得用）
}

/** カリキュラム内容 */
export interface ICurriculmContent {
	subCareerSetId: string; // 条件
	compulsoryID: string; // 区分
	careerTitle: string; // 研修名
	classTitle: string; // クラス名
	startDateODT: string; // 実施期間_開始日（Daoからの取得用）
	endDateODT: string; // 実施期間_終了日（Daoからの取得用）
	jissiKikan: string; // 実施期間
	classroom: string; // 実施場所
	cost: string; // 費用（円）
	credit: string; // 単位
	target: string; // 対象者
	organizer: string; // 教育主催者
	comment: string; // 備考
	compulsoryCssClass: string; // 区分値cssClass
	careerID: string; // キャリアID
	classID: string; // クラスID
	classStatus: string; // クラスステータス
	studyOrder: string; // 受講順
	applyUserId: string; // 受講申請ユーザ
	applyDateODT: string; // 受講申請日時（Daoからの取得用）
	applyDate: string; // 受講申請日時（UIへの返却用）
	approvalUserId: string; // 受講最終承認者
	approvalDateODT: string; // 受講承認日時（Daoからの取得用）
	approvalDate: string; // 受講承認日時（UIへの返却用）
	status: string; // ステータス
	statusNum: number; // ステータス（数値）
	careerTypeID: string; // キャリア種別
	careerType: string; // キャリア種別文字列
	outOfPeriodFlg: boolean; // 実施期間外フラグ
	appChangeOkFlg: boolean; // 申請変更可能フラグ（操作メニューに影響）
	appCancelOkFlg: boolean; // 申請取消可能フラグ（操作メニューに影響）
	lecCancelOkFlg: boolean; // 受講キャンセル可能フラグ（操作メニューに影響）
	appResultOkFlg: boolean; // 実績申請可能フラグ（操作メニューに影響）
	referenceOkFlg: boolean; // 実績参照可能フラグ（操作メニューに影響）
	certificateDispFlg: boolean; // 修了証明書ボタン表示フラグ（操作メニューに影響）
	enqueteDispFlg: boolean; // アンケート回答可能フラグ（操作メニューに影響）
	taskReportOkFlg: boolean; // 課題提出可能フラグ（操作メニューに影響）
	appLectureOkFlg: boolean; // 受講申請可能フラグ（操作メニューに影響）
	retakeOkFlg: boolean; // 再申請可能フラグ（操作メニューに影響）
	contentFlg: string; // コンテンツ存在判定用フラグ
	sikkouFlg: boolean; // 失効フラグ
	resultStatus: number; // 結果ステータス
	aplType: string; // 申請種別
	studentCareerExistFlg: string; // 学習者キャリア存在フラグ
	multiApplyFlag: string; // 再受講フラグ
	complDateODT: string; // 修了日（Daoからの取得用）
	startStudyDateODT: string; // 開始日（Daoからの取得用）
	complDate: string; // 修了日（画面への応答用）
	webAppFlg: string; // Web申込
	reasonCode: string; // 原因コード
	seq: string; // シーケンス番号
	certificateUploadFlg: boolean; // 証明書アップロード可能フラグ（操作メニューに影響）
	assessMentResultDispFlg: boolean; // アセスメント回答結果表示可能フラグ（操作メニューに影響）
	rankID: string; // ランクID
}

export interface ICancelStayMeal {
	careerID: string;
	classID: string;
	executionDate: string;
	stayFlg: string;
	mealMorningFlg: string;
	mealAfternoonFlg: string;
	mealEveningFlg: string;
	UID: string;
	comment: string;
	sexFlg: string;
	smokingFlg: string;
	date: string;
	week: string;
}

/** 受講申請情報 */
export interface IApplication {
	acceptManagerUserID?: string;
	acceptManagerUserID2?: string;
	acceptManagerUserID4?: string;
	actionKind?: string;
	approve1ActiveFlg?: boolean;
	approve1List?: IApplicationApprover[];
	approve2ActiveFlg?: boolean;
	approve2List?: IApplicationApprover[];
	approve4ActiveFlg?: boolean;
	approve4List?: IApplicationApprover[];
	capacity?: string;
	careerID?: string;
	careerTitle?: string;
	classID?: string;
	className?: string;
	kikan?: string;
	lang?: string;
	locale?: string;
	reason?: string;
	userId?: string;
	dayMealAfternoon?: string;
	dayMealEvening?: string;
	dayMealMorning?: string;
	dayStay?: string;
	postMealAfternoon?: string;
	postMealEvening?: string;
	postMealMorning?: string;
	preMealAfternoon?: string;
	preMealEvening?: string;
	preMealMorning?: string;
	preStay?: string;
	sex?: string;
	smoking?: string;
	stayMealFlg?: boolean;
	useFacilityFlg?: string;
}

/** 受講申請情報 */
export interface IApplicationStayMeal {
	application: IApplication;
	stayMealData: IApprovalStayMealData[];
}

/** 受講申請承認者情報 */
export interface IApplicationApprover {
	approverOptionString: string;
	objID: string;
	objName: string;
	userId: string;
}

export interface IScores {
	scoreID: string;
	scoreName: string;
	scores: string;
}

/** 実績申請情報 */
export interface IActResultApplication {
	managementCode?: string;
	careerTitle?: string;
	startDate?: string;
	endDate?: string;
	dateList?: IActResultSelect[];
	score?: string;
	studentCareerCode?: string;
	comment?: string;
	classList?: IActResultSelect[];
	updResult?: number;
	sel_Class?: string;
	sel_Endresult?: string;
	sel_Status?: string;
	validDate?: string;
	reason?: string;
	acceptManagerUserID?: string;
	acceptManagerUserID2?: string;
	approve1List?: IApplicationApprover[];
	approve2List?: IApplicationApprover[];
	validationType?: number;
	careerTypeID?: string;
	skillType?: string;
	certificationFlg?: string;
	certificationNewFile?: File;
	certificationFileName?: string;
	scoresID?: string;
	scores?: string;
	scoresList?: IScores[];
	scoreRegisterFlag?: string; // 得点登録
	scoreItemsRegisterFlag?: string; // 得点内訳登録
	assessmentHaveFlg?: string;
}

/** 実績申請選択肢情報 */
export interface IActResultSelect {
	objID: string;
	objName: string;
	scheduleId: string;
	nitteiString: string;
	startDateODT: string;
	endDateODT: string;
	selected: boolean;
	selectedSTR: string;
}

/** 進捗状況 */
export interface ITrainingProgress {
	approvalSubmitReport?: number;
	compEnquete?: number;
	compScoIndex?: number;
	compTestIndex?: number;
	compTextIndex?: number;
	complSubmitReport?: number;
	reqEnquete?: number;
	reqReport?: number;
	reqScoIndex?: number;
	reqTestIndex?: number;
	reqTextIndex?: number;
	scormFlg?: number;
}
/** 進捗状況データ状態 */
export type TrainingProgressState = 'none' | 'loading' | ITrainingProgress;

/** 申請内容 */
export interface IApplicationStatus {
	approvalStatus?: string;
	kaisaiKikan?: string;
	mousikomiStatus?: string;
	ph1_ApprovalNeedFlg?: number;
	ph1_ApproverString?: string;
	ph2_ApprovalNeedFlg?: number;
	ph2_ApproverString?: string;
	ph4_ApprovalNeedFlg?: number;
	ph4_ApproverString?: string;
	reason?: string;
}

/** テストアンケート情報 */
export interface IQuestionnaireSummary {
	id: string;
	title: string;
	kind: string;
	historyCount: number;
	historyList: IQuestionnaireHistory[];
	displayStyle: number;
	paperType: string;
}

/** テストアンケート履歴情報 */
export interface IQuestionnaireHistory {
	thistoryId: string;
	startDate: string;
	endDate: string;
	tokuten: string;
	enqueteUpdDate: string;
	disableFlg: string;
}

/** 実績参照 */
export interface IActResultReference {
	managementCode: string; // 管理番号
	careerTitle: string; // 研修名
	status: string; // 終了認定
	statusID: string; // 修了認定ID
	subStatus: string; // ステータス
	subStatusID: string; // ステータスID
	startDate: string; // 開始日
	endDate: string; // 終了日
	datelist: IActResultReferenceAgenda[]; // 日程
	result: string; // 得点
	studentCareerCode: string; // 認定番号
	comment: string; // コメント
	className: string; // クラス名
	lecturerComment: string; // 講師コメント
	scheduleId: string; // スケジュールID
	startDateODT: string; // 開始日（ODT）
	endDateODT: string; // 終了日（ODT）
	skillType?: string; // スキル種別
	validDate?: string; // 有効期限
	certificationFlg?: string; // 証明書フラグ
	certificationFileName?: string; // 認定証ファイル名
	scoresList?: IScores[]; // 得点内訳
	scoreRegisterFlag?: string; // 得点登録
	scoreItemsRegisterFlag?: string; // 得点内訳登録
}

/** 実績参照(日程) */
export interface IActResultReferenceAgenda {
	scheduleId: string; // 日程ID
	nitteiString: string; // 日程
	selected: string; // 選択フラグ
	startDateODT: string; // 開始日（ODT）
	startDate: string; // 開始日
	endDateODT: string; // 終了日（ODT）
	endDate: string; // 終了日
}

export interface ICareerDetailDialog {
	setApplicationStatusDialog: boolean;
	setOpenCareerDetailDialog: boolean;
	setOpenCurriculumDetailDialog: boolean;
	curriculumFlg: string;
	careerID: string;
	classID: string;
	apllType: string;
}

export const setCareerDetailDialog = actionCreator<{
	CareerDetailDialog: ICareerDetailDialog;
}>('SET_CAREER_DETAIL_DIALOG');

/** 実施中eラーニング表示形式設定アクションクリエータ */
export const setImstatOnGoingELearningShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_ON_GOING_ELEARNING_SHOW_TYPE');

/** 実施中eラーニングデータ設定アクションクリエータ */
export const setImstatOnGoingELearningData = actionCreator<{
	data: IOnGoingELearning[];
}>('SET_IMSTAT_ON_GOING_ELEARNING_DATA');

/** 実施中集合研修表示形式設定アクションクリエータ */
export const setImstatOnGoingGroupTrainingShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_ON_GOING_GROUP_TRAINING_SHOW_TYPE');
/** 実施中集合研修データ設定アクションクリエータ */
export const setImstatOnGoingGroupTrainingData = actionCreator<{
	data: IOnGoingGroupTraining[];
}>('SET_IMSTAT_ON_GOING_GROUP_TRAINING_DATA');

/** 実施中通信教育表示形式設定アクションクリエータ */
export const setImstatOnGoingDistanceLearningShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_ON_GOING_DISTANCE_LEARNING_SHOW_TYPE');

/** 実施中通信教育データ設定アクションクリエータ */
export const setImstatOnGoingDistanceLearningData = actionCreator<{
	data: IOnGoingDistanceLearning[];
}>('SET_IMSTAT_ON_GOING_DISTANCE_LEARNING_DATA');

/** 実施中カリキュラム表示形式設定アクションクリエータ */
export const setImstatOnGoingCurriculumShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_ON_GOING_CURRICULUM_SHOW_TYPE');

/** 実施中カリキュラムデータ設定アクションクリエータ */
export const setImstatOnGoingCurriculumData = actionCreator<{
	data: ICurriculum[];
}>('SET_IMSTAT_ON_GOING_CURRICULUM_DATA');

/** 実績eラーニング表示形式設定アクションクリエータ */
export const setImstatResultELearningShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_RESULT_ELEARNING_SHOW_TYPE');

/** 実績eラーニングデータ設定アクションクリエータ */
export const setImstatResultELearningData = actionCreator<{
	data: IResultELearning[];
}>('SET_IMSTAT_RESULT_ELEARNING_DATA');

/** 実績集合研修表示形式設定アクションクリエータ */
export const setImstatResultGroupTrainingShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_RESULT_GROUP_TRAINING_SHOW_TYPE');

/** 実績集合研修データ設定アクションクリエータ */
export const setImstatResultGroupTrainingData = actionCreator<{
	data: IResultGroupTraining[];
}>('SET_IMSTAT_RESULT_GROUP_TRAINING_DATA');

/** 実績通信教育表示形式設定アクションクリエータ */
export const setImstatResultDistanceLearningShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_RESULT_DISTANCE_LEARNING_SHOW_TYPE');

/** 実績通信教育データ設定アクションクリエータ */
export const setImstatResultDistanceLearningData = actionCreator<{
	data: IResultDistanceLearning[];
}>('SET_IMSTAT_RESULT_DISTANCE_LEARNING_DATA');

/** 実績カリキュラム表示形式設定アクションクリエータ */
export const setImstatResultCurriculumShowType = actionCreator<{
	showType: ImstatShowTypes;
}>('SET_IMSTAT_RESULT_CURRICULUM_SHOW_TYPE');

/** 実績カリキュラムデータ設定アクションクリエータ */
export const setImstatResultCurriculumData = actionCreator<{
	data: ICurriculum[];
}>('SET_IMSTAT_RESULT_CURRICULUM_DATA');

/** 実施中eラーニング表の表示カラム変更アクションクリエータ */
export const setImstatOnGoingELearningSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_ON_GOING_ELEARNING_SELECTED_COLUMNS');

/** 実績eラーニング表の表示カラム変更アクションクリエータ */
export const setImstatResultELearningSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_RESULT_ELEARNING_SELECTED_COLUMNS');

/** 実施中集合研修表の表示カラム変更アクションクリエータ */
export const setImstatOnGoingGroupTrainingSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_ON_GOING_GROUP_TRAINING_SELECTED_COLUMNS');

/** 実績集合研修表の表示カラム変更アクションクリエータ */
export const setImstatResultGroupTrainingSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_RESULT_GROUP_TRAINING_SELECTED_COLUMNS');

/** 実施中通信教育表の表示カラム変更アクションクリエータ */
export const setImstatOnGoingDistanceLearningSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_ON_GOING_DISTANCE_LEARNING_SELECTED_COLUMNS');

/** 実績通信教育表の表示カラム変更アクションクリエータ */
export const setImstatResultDistanceLearningSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_RESULT_DISTANCE_LEARNING_SELECTED_COLUMNS');

/** 実施中カリキュラム表の表示カラム変更アクションクリエータ */
export const setImstatOnGoingCurriculumSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_ON_GOING_CURRICULUM_SELECTED_COLUMNS');

/** 実績カリキュラム表の表示カラム変更アクションクリエータ */
export const setImstatResultCurriculumSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_IMSTAT_RESULT_CURRICULUM_SELECTED_COLUMNS');

/** 受講申請変更データ設定アクションクリエータ */
export const setChangeApplicationData = actionCreator<{
	data: IApplication;
}>('SET_CHANGE_APPLICATION_DATA');

/** 受講申請変更画面表示アクションクリエータ */
export const showChangeApplicationDialog = actionCreator<{
	dialogOpen: boolean;
}>('SHOW_CHANGE_APPLICATION_DIALOG');

/** 受講申請取消画面ダイアログ表示アクションクリエータ */
export const showCancelApplicationDialog = actionCreator<{
	dialogOpen: boolean;
}>('SHOW_CANCEL_APPLICATION_DIALOG');

/** 実績申請データ設定アクションクリエータ */
export const setActResultApplicationData = actionCreator<{
	data: IActResultApplication;
	backup?: boolean;
}>('SET_ACT_RESULT_APPLICATION_DATA');

/** 実績申請画面ダイアログ表示アクションクリエータ */
export const showActResultApplicationDialog = actionCreator<{
	saveSuccessDialogOpen: boolean;
	applySuccessDialogOpen: boolean;
}>('SHOW_ACT_RESULT_APPLICATION');

/** 受講取消データ設定アクションクリエータ */
export const setLectureCancelData = actionCreator<{
	data: IApplication;
}>('SET_LECTURE_CANCEL_DATA');

/** 受講取消画面ダイアログ表示アクションクリエータ */
export const showLectureCancelDialog = actionCreator<{
	dialogOpen: boolean;
}>('SHOW_LECTURE_CANCEL_DIALOG');

/** 進捗状況データ設定アクションクリエータ */
export const setTrainingProgress = actionCreator<{
	trainingProgress: TrainingProgressState;
}>('SET_TRAINING_PROGRESS');

/** 申請内容データ設定アクションクリエータ */
export const setApplicationStatusData = actionCreator<{
	data: IApplicationStatus;
}>('SET_APPLICATION_STATUS_DATA');

/** テスト・アンケート履歴データ設定アクションクリエータ */
export const setQuestionnaireHistoryData = actionCreator<{
	data: IQuestionnaireSummary[];
}>('SET_HISTORY_DATA');

/** カリキュラム内容画面データ設定アクションクリエータ */
export const setCurriculmContentData = actionCreator<{
	data: ICurriculmContent[];
}>('SET_CURRICULUM_CONTENT_DATA');

/** カリキュラム内容表の表示カラム変更アクションクリエータ */
export const setCurriculmContentSelectedColumns = actionCreator<{
	selectedColumns: number[];
}>('SET_CURRICULUM_CONTENT_SELECTED_COLUMNS');

/** 実績参照画面データ設定アクションクリエータ */
export const setActResultReferenceData = actionCreator<{
	data: IActResultReference;
}>('SET_ACT_RESULT_REFERENCE_DATA');

/** 実績参照画面データリセットアクションクリエータ */
export const resetActResultReferenceData = actionCreator<{}>(
	'RESET_ACT_RESULT_REFERENCE_DATA'
);

/** 実施状況画面の初期表示設定アクションクリエータ */
export const setImstatDefaultDisplaySettings = actionCreator<{
	defaultDisplayFormat: string;
	defaultDisplayTarget: string;
}>('SET_IMSTAT_DEFAULT_DISPLAY_SETTINGS');

/** 実施状況画面の初期表示設定アクションクリエータ */
export const setCancelStayMealData = actionCreator<{
	cancelStayMealData: ICancelStayMeal[];
}>('SET_CANCEL_STAY_MEAL_DATA');

/** 実施状況初期化アクションクリエータ */
export const clearImstat = actionCreator('CLEAR_IMSTAT');



// WEBPACK FOOTER //
// ./src/actions/imstat.ts